export const SIDE_NAVBAR = 'sideNavBar';
export const COLLAPSE_MAP = 'collapseMap';
export const ITEM_KEY = 'itemKey';
export const ITEM_COLLAPSE = 'itemCollapse';
export const TOGGLE_COLLAPSE = 'sideNavBar/TOGGLE_COLLAPSE';
